export const legacyMCW = {
  path: '/MCW',
  component: () => import('@/views/MCW/legacy/MCW.vue'),
  children: [
    {
      path: 'Terms',
      name: 'MCWTerms',
      component: () => import('@/views/common/Views/Terms.vue')
    },
    {
      path: 'Invoices',
      name: 'MCWInvoices',
      component: () => import('@/views/MCW/legacy/Invoices.vue')
    },
    {
      path: 'PaymentStatus/:folio',
      name: 'PaymentStatusMcw',
      component: () => import('@/views/MCW/legacy/PaymentInfo.vue')
    },
    {
      path: 'Error',
      name: 'ErrorMCW',
      component: () => import('@/views/common/legacyError')
    },
    {
      path: 'RecurringPaymentActivationToken',
      name: 'MCWRecurringPaymentActivationToken',
      component: () => import('@/views/MCW/legacy/RecurringPaymentActivationToken.vue')
    },
    {
      path: 'BuyError',
      name: 'BuyErrorMCW',
      component: () => import('@/views/common/legacyError'),
      props: { defaultError: 'DECLINED_TRANSACTION' }
    },
    {
      path: 'CambiarTarjeta',
      name: 'ChangeCardMCW',
      component: () => import('@/views/MCW/legacy/ChangeCard.vue')
    },
    {
      path: '/Iframe/RecurrenceInvoices',
      name: 'RecurrenceInvoices',
      component: () => import('@/views/MCW/legacy/RecurrenceInvoicesIframe/RecurrenceInvoices.vue')
    },
    {
      path: '/Iframe/RecurrenceInvoices/Error',
      name: 'ErrorRecurrenceInvoices',
      component: () => import('@/views/common/ErrorView')
    }
  ]
};

export const MCW = {
  path: '/MCW',
  component: () => import('@/layouts/MCW.vue'),
  children: [
    {
      path: 'Terms',
      name: 'MCWTerms',
      component: () => import('@/views/Terms')
    },
    {
      path: 'Invoices',
      name: 'MCWInvoices',
      component: () => import('@/views/MCW/Invoices.vue')
    },
    {
      path: 'Error',
      name: 'ErrorMCW',
      component: () => import('@/views/common/ErrorView')
    },
    {
      path: 'PaymentStatus/:folio',
      name: 'PaymentStatusMcw',
      component: () => import('@/views/MCW/PaymentStatus.vue')
    },
    {
      path: 'BuyError',
      name: 'BuyErrorMCW',
      component: () => import('@/views/common/ErrorView'),
      props: { defaultError: 'DECLINED_TRANSACTION' }
    },
    {
      path: 'RecurringPaymentActivationToken',
      name: 'MCWRecurringPaymentActivationToken',
      component: () => import('@/views/MCW/RecurrenceResult.vue')
    },
    {
      path: 'CambiarTarjeta',
      name: 'ChangeCardMCW',
      component: () => import('@/views/MCW/ChangeCardSuccess.vue')
    },
    {
      path: '/Iframe/RecurrenceInvoices',
      name: 'RecurrenceInvoices',
      component: () => import('@/views/MCW/Recurrence/RecurrenceInvoices.vue')
    },
    {
      path: '/Iframe/RecurrenceInvoices/Error',
      name: 'ErrorRecurrenceInvoices',
      component: () => import('@/views/common/ErrorView')
    }
  ]
};

